import { render, staticRenderFns } from "./SharePost.vue?vue&type=template&id=88b1474e&scoped=true"
import script from "./SharePost.vue?vue&type=script&lang=js"
export * from "./SharePost.vue?vue&type=script&lang=js"
import style0 from "./SharePost.vue?vue&type=style&index=0&id=88b1474e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b1474e",
  null
  
)

export default component.exports